@use '@/styles/tokens' as *;

// Payment-status chip colorways (Figma node 8087-814567 / 7522-303033). Five statuses map exactly
// to existing design tokens; the remaining four use their Figma-exact hex (no shared token yet).
.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 18px;
  padding: 3px 8px;
  border-radius: 24px;
  font-size: 11px;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
}

.pending {
  background: $color-stage-review-bg; // #fddc69
  color: $color-stage-review-text; // #684e00
}

.success {
  background: $color-stage-approved-bg; // #a7f0ba
  color: $color-brand-700; // #3d5b34
}

.failed,
.capture_failed {
  background: $color-error-100; // #ffdfdf
  color: $color-stage-attention-text; // #a2191f
}

.on_hold {
  background: $color-info-100; // #cdecff
  color: $color-info-700; // #357edd
}

.debited {
  background: #eff0a7;
  color: $color-brand-700; // #3d5b34
}

.released {
  background: #eed4ff;
  color: #9a35dd;
}

.refund_initiated {
  background: #fff4d7;
  color: #996f00;
}

.refunded {
  background: #fff0df;
  color: #af5d01;
}
